<template>
  <div
    class="fixed md:bottom-6 right-0 max-md:left-0 mx-2 md:mx-6 z-50 space-y-2"
    :class="{
      'bottom-20 m-1': isAuthed,
      'bottom-4': !isAuthed
    }"
    >
    <span class="absolute -top-12 right-0">
      <UiButton
        :svg="showPopUp ? 'fa fa-arrow-down' : 'fa fa-headset md:text-xl'"
        class="!rounded-full dark !aspect-square !shadow !shadow-gray-200"
        @click="showPopUp = !showPopUp"/>

      <div
        v-if="unreadCount"
        class="absolute -right-1 -top-1 bg-red-500 aspect-square h-5 rounded-full text-white text-center text-sm"
        v-text="unreadCount"
        />
    </span>

    <div v-show="showPopUp" class="rounded-2xl">
      <div
        class="ui-card ml-auto md:w-[500px] max-w-full !p-0 !flex !flex-col !flex-grow relative !space-y-3 !shadow-xl !shadow-gray-400 max-h-[70vh] overflow-auto"
        >
        <UniqueSupportChat
          v-if="dataSession"
          ref="refChatWindow"
          v-model:session="dataSession"
          v-model:popup="showPopUp"
          @new-message="methodNewMessageReceived"
          @finished="methodChatFinished()"
          />

        <UniqueSupportSelect
          v-show="!dataSession"
          ref="refSelectWindow"
          v-model:popup="showPopUp"
          v-model:session="dataSession"
          />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const refSelectWindow = ref<InstanceType<typeof import('./Select.vue').default> | null>(null)
const refChatWindow = ref<InstanceType<typeof import('./Chat.vue').default> | null>(null)

const showPopUp = ref<boolean>(false)
const dataSession = ref<string|null>(null)
const unreadCount = ref<number>(0)
const lastSoundPlayed = ref<number|null>(null)
const dataIsSessionFinished = ref<boolean>(false)

onMounted(() => {

  // === Listen for new support requests
  ws.listenWhileMounted<{
    message: string,
    type: string
  }>('info:support_request', null, (data: any) => {
    if (!showPopUp.value){
      notify(data.message)
    }

    methodSetSession(data.session);

    showPopUp.value = true

    methodNewMessageReceived()
  })

  // === Listen for new support messages
  ws.listenWhileMounted<{
    message: string,
    type: string
  }>('info:new_support_messages', null, (data: any) => {
    if(data?.unread_count && data?.unread_count != unreadCount.value){
      methodNewMessageReceived()
    }

    unreadCount.value = data.unread_count ?? 0

    if ((user.value as User)?.is_admin ?? false){
      refSelectWindow.value?.methodShowOpenSessions()
    }
  })

  // === Load session from local storage
  if (localStorage.getItem('support_session')){
    dataSession.value = localStorage.getItem('support_session')
    showPopUp.value = true
  }
})

const methodNewMessageReceived = () => {
  if(lastSoundPlayed.value && (Date.now() - lastSoundPlayed.value) < 1000){
    return
  }

  lastSoundPlayed.value = Date.now()

  new Audio(api.getBackendUrl()+'warehouse/newmessage.mp3?clientasset=true').play().catch(() => {})

  if (!((user.value as User)?.is_admin ?? false) && !showPopUp.value){
    unreadCount.value = unreadCount.value + 1
  }
}

const methodChatFinished = () => {
  localStorage.removeItem('support_session')
  dataIsSessionFinished.value = true
}

const methodSetSession = (newsession: string|null) => {
  if(!dataIsSessionFinished.value) {
    return
  }

  if (dataSession.value){
    dataSession.value = null

    return setTimeout(() => {
      if(dataSession.value)
        return

      dataSession.value = newsession
    }, 100)
  }

  dataSession.value = newsession
}

watch(dataSession, (session: string|null) => {
  if(session){
    localStorage.setItem('support_session', session)
    dataIsSessionFinished.value = false
  }else{
    localStorage.removeItem('support_session')
  }
})

watch(showPopUp, (isVisible: boolean) => {
  if(isVisible){
    unreadCount.value = 0
    refChatWindow.value?.methodScrollDown()
  }
})
</script>
